<script setup lang="ts">
defineProps<{
  color?: any
}>()
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 35 35"
    :style="color"
    class="eb-icon-nosize w-10 h-10 p-1"
  >
    <path
      d="M11.159,33.807c-9.006-3.503-13.466-13.64-9.966-22.647C4.696,2.153,14.837-2.31,23.841,1.196
c9.006,3.498,13.466,13.642,9.966,22.645C30.304,32.849,20.163,37.308,11.159,33.807"
    />
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256">
      <rect
        x="50"
        y="50"
        width="156"
        height="156"
        rx="20"
        fill="none"
        stroke="#FFF"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="8"
      />
      <line
        x1="160"
        y1="98"
        x2="96"
        y2="98"
        fill="none"
        stroke="#FFF"
        stroke-width="17"
      />
      <line
        x1="128"
        y1="168"
        x2="128"
        y2="95"
        fill="none"
        stroke="#FFF"
        stroke-width="17"
      />
    </svg>
  </svg>
</template>
